<template>
  <div @contextmenu.prevent="disableRightClick">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    disableRightClick(event) {
      event.preventDefault();
    },
    disableShortcuts(event) {
      if (
        event.key === "F12" ||
        (event.ctrlKey && event.shiftKey && ["I", "J", "C"].includes(event.key)) ||
        (event.ctrlKey && event.key === "S") ||
        (event.ctrlKey && event.key === "U")
      ) {
        event.preventDefault();
      }
    }
  },
  mounted() {
    // Attach keyboard shortcut listener
    document.addEventListener("keydown", this.disableShortcuts);
  },
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener("keydown", this.disableShortcuts);
  }
}
</script>

<style>
  // Import Font Awesome Icons Set
  $fa-font-path: "~font-awesome/fonts/";
  @import "~font-awesome/css/font-awesome.min.css";
  // Import Simple Line Icons Set
  $simple-line-font-path: "~simple-line-icons/fonts/";
  @import "~simple-line-icons/css/simple-line-icons.css";
</style>
<style lang="scss">
  // Import Main styles for this application
  @import "./scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue?07fc6a16